/**
 * @file verifyLanding.js
 * @description What the app does after an email verification link succeeds (App.js ?token= handler).
 *
 *   The verify RPC marks ITS OWN account verified (data.user_id), whatever browser opens the link. The welcome email
 *   follows on the server (profiles trigger on_profile_email_verified_welcome), so this only decides the screen:
 *   - "continue": the verified account is logged in here. Refresh the profile and carry on (onboarding).
 *   - "login": nobody is logged in here, often a link from the Facebook or Instagram app opening in Safari or Chrome.
 *     Open the login screen with a "verified, log in to finish" note instead of leaving them on the home page.
 *   - "switch_account": a different account is logged in here. Sign it out, then the same login screen.
 * @module lib/verifyLanding
 */

/**
 * @param {{ verifiedUid: string|null, sessionUid: string|null }} ids
 * @returns {"continue"|"login"|"switch_account"}
 */
export function verifyLandingAction({ verifiedUid, sessionUid }) {
  if (sessionUid && verifiedUid && sessionUid !== verifiedUid) return "switch_account";
  // Logged in here as the verified account, or (never today) the RPC did not say which account: carry on.
  if (sessionUid) return "continue";
  return "login";
}
